import { render, staticRenderFns } from "./NeoparentNurses.vue?vue&type=template&id=25f0cdd5&scoped=true"
import script from "./NeoparentNurses.vue?vue&type=script&lang=js"
export * from "./NeoparentNurses.vue?vue&type=script&lang=js"
import style0 from "./NeoparentNurses.vue?vue&type=style&index=0&id=25f0cdd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0cdd5",
  null
  
)

export default component.exports